import { useEffect, useRef, useState } from 'react';

interface UseStickySubmitVisibilityReturn {
  submitRowRef: React.RefObject<HTMLDivElement | null>;
  isSubmitOutOfView: boolean;
}

export function useStickySubmitVisibility(enabled: boolean): UseStickySubmitVisibilityReturn {
  const submitRowRef = useRef<HTMLDivElement>(null);
  const [isSubmitOutOfView, setIsSubmitOutOfView] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setIsSubmitOutOfView(false);
      return;
    }
    const el = submitRowRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        // ボタンが画面下方向にスクロールアウトした場合のみstickyを表示
        // (上方向に消えた場合＝シナリオ結果を見ている場合は表示しない)
        const belowViewport = entry.boundingClientRect.top > 0;
        setIsSubmitOutOfView(!entry.isIntersecting && belowViewport);
      },
      { threshold: 0, rootMargin: '0px 0px -95px 0px' },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [enabled]);

  return { submitRowRef, isSubmitOutOfView };
}
